<template>
  <v-layout wrap>
    <v-flex xs12 mb-5 pb-0>
      <v-layout wrap align-center>
        <v-flex xs12 sm6 md6 lg6>
          <h1 class="headline">{{ $t('parks.title') }}</h1>
        </v-flex>

        <v-flex xs12 sm6 md6 lg6>
          <v-layout wrap align-center justify-end>
            <v-btn
              v-if="$can('car_park_add')"
              color="warning mt-2"
              large
              depressed
              @click="dialog = true"
            >
              {{ $t('parks.add') }}
            </v-btn>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-checkbox
      v-if="isAdmin"
      v-model="withTrashed"
      color="warning"
      true-value="1"
      false-value="0"
      hide-details
      :label="$t('common.labels.showDeleted')"
    />

    <v-flex mt-5 mb-5 xs12>
      <v-data-table
        :headers="headers"
        :items="list"
        :loading="loading"
        hide-default-footer
      >
        <template #item="{item}">
          <tr :class="{ 'deleted-row': item.deleted_at }">
            <td v-if="isAdmin" width="100">
              <v-btn
                v-if="item.deleted_at"
                class="restore-btn"
                color="warning"
                small
                icon
                :loading="restoreItems.includes(item.id)"
                @click="
                  () => {
                    confirmDialog.value = true;
                    confirmDialog.title = $t('common.restore') + ' ?';
                    confirmDialog.action = () => restoreItem(item.id);
                  }
                "
              >
                <v-icon small>mdi-restore</v-icon>
              </v-btn>
              <v-btn
                v-else
                color="red"
                small
                icon
                :loading="deletingItems.includes(item.id)"
                :disabled="item.deleted_at"
                @click="
                  () => {
                    confirmDialog.value = true;
                    confirmDialog.title = $t('common.btns.delete') + ' ?';
                    confirmDialog.action = () => deleteItem(item.id);
                  }
                "
              >
                <v-icon small>mdi-trash-can-outline</v-icon>
              </v-btn>
            </td>
            <td>{{ item.num }}</td>
            <td>
              <button
                class="parks-list__btn"
                @click="
                  () => {
                    editData = item;
                    dialog = true;
                  }
                "
              >
                {{ item.name }}
              </button>
            </td>
            <td>
              {{ item.description }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>

    <confirm-dialog
      v-model="confirmDialog.value"
      :title="confirmDialog.title"
      @confirm="confirmDialog.action"
    />

    <v-snackbar v-model="snack.value" :color="snack.color" bottom right>
      {{ snack.message }}
    </v-snackbar>

    <add-park-dialog
      v-model="dialog"
      :item="editData"
      @closed="editData = null"
      @updated="onAddNew"
    />
  </v-layout>
</template>

<script>
import AddParkDialog from '@/components/parks/AddParkDialog.vue';
import ConfirmDialog from '../../components/shared/ConfirmDialog.vue';

export default {
  components: { AddParkDialog, ConfirmDialog },
  data: () => ({
    loading: false,
    withTrashed: 0,
    dialog: false,
    editData: null,
    deletingItems: [],
    restoreItems: [],

    confirmDialog: {
      value: false,
      title: null,
      action: null,
    },
    snack: {
      value: null,
      color: null,
      message: null,
    },
  }),
  watch: {
    withTrashed() {
      this.fetchList();
    },
  },
  computed: {
    headers() {
      const items = [
        {
          text: this.$t('common.number'),
          value: 'num',
          sortable: false,
        },
        {
          text: this.$t('companiesList.tableHeaders.name'),
          value: 'name',
          sortable: false,
        },
        {
          text: this.$t('common.table.description'),
          value: 'description',
          sortable: false,
        },
      ];

      if (this.isAdmin) {
        items.unshift({
          text: '',
          value: 'actions',
          sortable: false,
        });
      }

      return items;
    },
    list() {
      return this.$store.state.parks.list;
    },
    isAdmin() {
      return this.$store.getters['global/getRole'] === 'admin';
    },
  },
  methods: {
    async fetchList() {
      this.loading = true;
      await this.$store.dispatch('parks/fetchList', {
        withTrashed: this.withTrashed,
      });
      this.loading = false;
    },

    processResult({ success, error }) {
      if (success) this.fetchList();

      const snack = {
        value: true,
        color: 'success',
        message: this.$t('common.saved'),
      };

      if (error) {
        snack.color = 'error';
        snack.message = error || this.$t('common.errors.APIerror');
      }

      this.snack = snack;
    },

    async onAddNew(result) {
      await this.processResult(result);
      this.dialog = false;
    },

    async deleteItem(id) {
      this.deletingItems.push(id);

      const result = await this.$store.dispatch('parks/deleteItem', id);

      this.processResult(result);
      this.deletingItems = this.deletingItems.filter((item) => item !== id);
    },
    async restoreItem(id) {
      this.restoreItems.push(id);

      const result = await this.$store.dispatch('parks/restoreItem', id);

      this.processResult(result);
      this.restoreItems = this.restoreItems.filter((item) => item !== id);
    },
  },
  created() {
    this.fetchList();
  },
};
</script>

<style>
.confirm-title {
  width: 100%;
  text-align: center;
  font-size: 20px;
}

.parks-list__btn {
  text-decoration: underline;
  font-weight: 600;
  color: #464646;
}

.parks-list__btn:hover:not([disabled]) {
  text-decoration: none;
}

.parks-list__btn[disabled] {
  opacity: 0.7;
}
</style>
